/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

/**
 * Returns a cache propType object.
 * @param {Object} config
 * @param {('any'|'array'|'element'|'object'|'number'|'string')} config.dataType
 * @param {('any'|'array'|'element'|'object'|'number'|'string')} config.responseType
 * @returns {Object}
 */

export const cache = ({ dataType = 'object', responseType } = {}) => PropTypes.shape({
  data: PropTypes[dataType],
  ...(responseType && { response: PropTypes[responseType] }),
  set: PropTypes.func,
  fetch: PropTypes.func,
  status: PropTypes.oneOf(['idle', 'unresolved', 'loading', 'syncing', 'success', 'error']),
});

export const location = PropTypes.shape({
  pathname: PropTypes.string,
  search: PropTypes.string,
  href: PropTypes.string,
});
